import React, { createContext, useState, useEffect } from 'react';
import { login, logout, verifyToken } from '../api/api';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        const checkAuth = async () => {
            const valid = await verifyToken();
            setIsAuthenticated(valid);
        };
        checkAuth();
    }, []);

    const handleLogin = async (email, password) => {
        const result = await login(email, password);
        setIsAuthenticated(result.success);
        return result;
    };

    const handleLogout = () => {
        logout();
        setIsAuthenticated(false);
    };

    return (
        <AuthContext.Provider value={{ isAuthenticated, handleLogin, handleLogout }}>
            {children}
        </AuthContext.Provider>
    );
};

